import { render, staticRenderFns } from "./TaskInfoTab.vue?vue&type=template&id=23926e76&scoped=true&"
import script from "./TaskInfoTab.vue?vue&type=script&lang=js&"
export * from "./TaskInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfoTab.vue?vue&type=style&index=0&id=23926e76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23926e76",
  null
  
)

export default component.exports